import {
  Injector,
  NgModule,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { MdSidenav, MdSidenavModule } from '@angular/material';
import { CommonModule } from '@angular/common';

import { OSharedModule } from '../../shared';
// import { OAppSidenavComponent } from './o-app-sidenav.component';

export const DEFAULT_INPUTS_O_APP_SIDENAV_IMAGE = [
  'openedSrc:  opened-src',
  'closedSrc: closed-src'
];

export const DEFAULT_OUTPUTS_O_APP_SIDENAV_IMAGE = [
];


export class OAppSidenavImageComponent implements OnInit {

  public static DEFAULT_INPUTS_O_APP_SIDENAV_IMAGE = DEFAULT_INPUTS_O_APP_SIDENAV_IMAGE;
  public static DEFAULT_OUTPUTS_O_APP_SIDENAV_IMAGE = DEFAULT_OUTPUTS_O_APP_SIDENAV_IMAGE;

  // protected sidenavComp: OAppSidenavComponent;
  protected sidenav: MdSidenav;
  protected openedSrc: string;
  protected closedSrc: string;
  private _src: string;

  constructor(
    protected injector: Injector
  ) {
    // this.sidenavComp = this.injector.get(OAppSidenavComponent);
    // this.sidenav = this.sidenavComp ? this.sidenavComp.sidenav : undefined;
    this.sidenav = this.injector.get(MdSidenav);

  }

  ngOnInit() {
    if (this.sidenav) {
      let self = this;
      this.sidenav.onOpen.subscribe(() => {
        self.setOpenedImg();
      });
      this.sidenav.onClose.subscribe(() => {
        self.setClosedImg();
      });
      if (this.sidenav.opened) {
        this.setOpenedImg();
      } else {
        this.setClosedImg();
      }
    }
  }

  set src(val: string) {
    this._src = val;
  }

  get src() {
    return this._src;
  }

  setOpenedImg() {
    this.src = this.openedSrc;
  }

  setClosedImg() {
    this.src = this.closedSrc;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-app-sidenav-image',
  inputs: DEFAULT_INPUTS_O_APP_SIDENAV_IMAGE,
  outputs: DEFAULT_OUTPUTS_O_APP_SIDENAV_IMAGE,
  template: `
    <div class="application-sidenav-image-container" o-app-sidenav-image fxLayout="row" fxLayoutAlign="center" *ngIf="src!==undefined">
      <img class="application-sidenav-image" [src]="src"/>
    </div>
  `,
  styles: [`
    o-app-sidenav-image .application-sidenav-image-container{max-height:75px;padding:16px}o-app-sidenav-image .application-sidenav-image-container .application-sidenav-image{max-width:100%;max-height:100%}
  `],
  encapsulation: ViewEncapsulation.None,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
];
}


export class OAppSidenavImageModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    OSharedModule,
    MdSidenavModule
  ],
  declarations: [
    OAppSidenavImageComponent
  ],
  exports: [OAppSidenavImageComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
